<div class="modal-header">
  <h5 class="modal-title" id="inactivity-title">Opozorilo</h5>
  <button type="button" class="btn-close" aria-label="Ostani prijavljen" (click)="stay()"></button>
</div>
<div class="modal-body bg-light">
  <p class="mb-0" role="alert">
    V primeru daljše neaktivnosti vas portal MOST iz varnostnih razlogov odjavi iz sistema. V kolikor
    želite nadaljevati delo s sistemom, izberite gumb <b>Ostani prijavljen</b>, sicer boste avtomatično
    odjavljeni čez <b>{{ secondsLeft() }} s</b>.
  </p>
</div>
<div class="modal-body bg-light inactivity-actions">
  <button type="button" class="btn btn-primary" (click)="logout()">Odjava</button>
  <button type="button" class="btn btn-primary" (click)="stay()">Ostani prijavljen</button>
</div>
